export const data = {
    infoenergo: {
        gallery : [
            {
                path:'images/06_min.jpg',
                name:'100500',
                h1:'Энергоснабжение для бизнеса на розничном рынке',
                subh1:'Минимальные сроки заключения договора'
            }
        ],
        slideTwoBottomHomePage:{
            header:'Энергоснабжение для бизнеса на розничном рынке',
            secondary : 'Минимальные сроки заключения договора'
        },
        themes2 : [{
            'ID': 12,
            'NameTheme': 'generic.light',
            'NameRus': 'Инфоэнерго',
            'Img': 'generic.light'
        }],
},
    esg: {
        gallery : [
            {
                path:'images/06_min.jpg',
                name:'100500',
                h1:'Энергоснабжение для бизнеса на розничном рынке',
                subh1:'Цены ниже Гарантирующего поставщика, минимальные сроки заключения договора'
            }
        ],
        slideTwoBottomHomePage:{
            header:'Энергоснабжение для бизнеса на розничном рынке',
            secondary : 'Цены ниже Гарантирующего поставщика, минимальные сроки заключения договора'
        },
        themes2 : [{
            'ID': 12,
            'NameTheme': 'generic.light',
            'NameRus': 'ЕЭСГ',
            'Img': 'generic.light'
        }],
},
    garant: {
        gallery : [
            {
                path:'images/img.jpg',
                name:'Гарант Плюс',
                h1:'Гарант Плюс',
                subh1:'Комплексные решения в сфере энергоснабжения ' +
                    'и энергосбережения для вашего бизнеса'
            },{
                path:'images/img_1.jpg',
                name:'Гарант Плюс',
                h1:'Энергоснабжение для бизнеса на розничном рынке',
                subh1:'Цены ниже Гарантирующего поставщика, минимальные сроки заключения договора'
            }
        ],
        slideTwoBottomHomePage:{
            header:'Энергоснабжение для бизнеса на розничном рынке',
            secondary : 'Минимальные сроки заключения договора'
        },
        themes2 : [{
            'ID': 12,
            'NameTheme': 'generic.light',
            'NameRus': 'Гарант Плюс',
            'Img': 'generic.light'
        }],
    },
    renergy: {
        gallery : [
            {
                path:'images/06_min.jpg',
                name:rgmek(),
                h1:'Энергоснабжение для бизнеса на розничном рынке',
                subh1:'Минимальные сроки заключения договора'
            }
        ],
        slideTwoBottomHomePage:{
            header:'Энергоснабжение для бизнеса на розничном рынке',
            secondary : 'Минимальные сроки заключения договора'
        },
        themes2 : [{
            'ID': 12,
            'NameTheme': 'generic.light',
            'NameRus': rgmek(),
            'Img': 'generic.light'
        }],
    },
    tatenergosbyt: {
        gallery : [
            {
                path:'images/lamp-tatenergosbyt.jpg',
                name:'Татэнергосбыт',
                h1:'Татэнергосбыт',
                subh1:'Ограничение электроснабжения'
            },{
                path:'images/counter-tatenergosbyt.jpg',
                name:'Татэнергосбыт',
                h1:'Поверка, установка',
                subh1:'Замена приборов учёта электроэнергии'
            }
        ],
        slideTwoBottomHomePage:{
            header:'Энергоснабжение для бизнеса на розничном рынке',
            secondary : 'Минимальные сроки заключения договора'
        },
        themes2 : [{
            'ID': 12,
            'NameTheme': 'generic.light',
            'NameRus': 'Татэнергосбыт',
            'Img': 'generic.light'
        }],
    },
}
function rgmek(){
    let t = (process.env.REACT_APP_NAME_ENV === 'renergy' && new Date().getFullYear() < 2025) ? '2': ''
    return process.env['REACT_APP_TITLE' + t]
}
